import * as React from 'react';
import './Spinner.scss';
import { ClassableProps, baseClassAnd } from "@jcharlesworthuk/your-mum-core/dist/functions";

const Spinner: React.FunctionComponent<ClassableProps> = props => {

    return <div className={baseClassAnd('spinner', props)}></div>
}

export default Spinner;